import View from '../Support/View/View';

export default class Sharer extends View {

    static get viewName() {
        return 'sharer';
    }
    static get viewType() {
        return 'component';
    }

    start() {
        this.addEventHandler('click', this.#onClick.bind(this));
    }

    /**
     * @return {string}
     */
    get type() {
        return this.viewData.type;
    }

    /**
     * @param {MouseEvent} e
     */
    #onClick(e) {
        this.#share();
    }

    #share() {
        switch (this.type) {
            case 'facebook':
                this.#shareOnFacebook();
                break;
            case 'linkedin':
                this.#shareOnLinkedin();
                break;
            default:
                break;
        }
    }
    #shareOnFacebook() {
        const url      = window.location.href;
        const shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url);

        this.#popupCenter(shareUrl, this.$el.getAttribute('aria-label') ?? this.$el.getAttribute('title') ?? 'Partager sur Facebook');
    }
    #shareOnLinkedin() {
        const url      = window.location.href;
        const shareUrl = 'https://www.linkedin.com/shareArticle?url=' + encodeURIComponent(url);

        this.#popupCenter(shareUrl, this.$el.getAttribute('aria-label') ?? this.$el.getAttribute('title') ?? 'Partager sur LinkedIn');
    }

    #popupCenter(url, title, width, height) {
        const popupWidth   = width  || 640;
        const popupHeight  = height || 320;

        const windowLeft   = window.screenLeft  || window.screenX;
        const windowTop    = window.screenTop   || window.screenY;
        const windowWidth  = window.innerWidth  || document.documentElement.clientWidth;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;

        const popupLeft    = windowLeft + windowWidth / 2 - popupWidth / 2;
        const popupTop     = windowTop + windowHeight / 2 - popupHeight / 2;
        const popup        = window.open(url, title,  `scrollbars=yes, width=${popupWidth}, height=${popupHeight}, top=${popupTop}, left=${popupLeft}`);

        popup.focus();
    }
}